import type { DocumentSummary } from "~/api/types";
import type { UpdateDocumentData } from "~/api/v2/requests";
import type {
  DocumentEditableField,
  EditableField,
  VersionEditableField,
} from "./libraryTypes";

export const isVersionEditableField = (
  field: EditableField,
): field is VersionEditableField =>
  field === "reviewFrom" || field === "reviewTo" || field === "adoptedAt";

export const isEditableField = (
  document: DocumentSummary,
  field: EditableField | undefined,
): boolean => {
  if (field === undefined) return false;

  if (document.archivedAt !== null) {
    return false;
  }

  if (field === "adoptedAt") {
    return false;
  }

  if (field === "reviewFrom") {
    return !document.latestVersion.isWorkflowOngoing;
  }

  return true;
};

const payloadKeysByEditableField: Record<
  DocumentEditableField,
  (keyof UpdateDocumentData)[]
> = {
  categoryId: ["categoryId"],
  tierId: ["tierId", "linkedDocumentIds"],
  referenceNumber: ["referenceNumber"],
  ownerId: ["ownerId"],
  publisherId: ["publisherId"],
  tags: ["tagIds"],
  links: ["linkedDocumentIds"],
};

export const getPayloadForField = (
  field: DocumentEditableField,
  payload: UpdateDocumentData,
): UpdateDocumentData =>
  Object.fromEntries(
    Object.entries(payload).filter(([key]) =>
      payloadKeysByEditableField[field].includes(
        key as keyof UpdateDocumentData,
      ),
    ),
  );
